const EndorsementInsuredData = ({
  name,
  document,
}) => ({
  name: name ?? '',
  document: document ?? '',
})

export default EndorsementInsuredData
